export const PARTNER_SOURCES = [
    {value: 'Posbel', label: 'Posbel'},
    {value: 'MONNI', label: 'Monni'},
    {value: 'NA', label: 'N/A'}
];

export function buildPartnerSourceOptions(t) {
    return [
        {id: '', name: t('generic.none')},
        ...PARTNER_SOURCES.map(source => ({id: source.value, name: source.label}))
    ];
}

export function buildPartnerSourceSettingOptions() {
    return [
        {value: null, label: ''},
        ...PARTNER_SOURCES
    ];
}
